// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_zJZkR","content":"index_content_AdPCY","ad":"index_ad_5DKLn","title":"index_title_wkHzr","leaderSupport":"index_leaderSupport_XV2ay","beer":"index_beer_5DpiQ"};